// アコーディオン
const initializeDetailsAccordion = (details) => {
  const summary = details.querySelector("summary");
  const panel = details.querySelector("summary + *");

  if (!(details && summary && panel)) return; // 必要要素が揃ってない場合は処理をやめる

  let isTransitioning = false; // 連打防止フラグ

  const onOpen = () => {
    if (details.open || isTransitioning) {
      return;
    }
    isTransitioning = true;
    details.setAttribute("open", "");
    panel.style.blockSize = "0px";
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        panel.style.blockSize = `${panel.scrollHeight}px`;
      });
    });
    panel.addEventListener(
      "transitionend",
      () => {
        panel.style.blockSize = "";
        isTransitioning = false;
      },
      { once: true }
    );
  };

  const onClose = () => {
    if (!details.open || isTransitioning) {
      return;
    }
    isTransitioning = true;
    panel.style.blockSize = `${panel.scrollHeight}px`;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        panel.style.blockSize = "0";
      });
    });
    panel.addEventListener(
      "transitionend",
      () => {
        details.removeAttribute("open");
        panel.style.blockSize = "";
        isTransitioning = false;
      },
      { once: true }
    );
  };

  summary.addEventListener("click", (event) => {
    event.preventDefault();

    if (details.open) {
      onClose();
    } else {
      onOpen();
    }
  });
};

document
  .querySelectorAll(".image-lp-faq__details")
  .forEach((accordion) => {
    initializeDetailsAccordion(accordion);
  });
